import { ref } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';

export const useCaptcha = () => {
  const showRecaptcha = ref(false);
  const recaptcha = ref<InstanceType<typeof VueRecaptcha> | null>(null);

  const toggleShowRecaptcha = (toggle: boolean = false) => {
    showRecaptcha.value = toggle;
  };

  const onCaptchaExpired = () => {
    recaptcha.value?.reset();
  };

  const onCaptchaVerified = (token: string, callback?: (token: string) => void) => {
    showRecaptcha.value = false;
    callback(token);
  };

  return {
    showRecaptcha,
    toggleShowRecaptcha,
    recaptcha,
    onCaptchaExpired,
    onCaptchaVerified,
  };
}
